import { inject, computed } from 'vue';

export default function reusableBase() {
  const moment = inject('$moment');

  const renderDateFormat = (val) => {
    if (!val) return '';
    return moment(val).format('LL');
  };
  const renderDateTimeFormat = (val) => {
    if (!val) return '';
    return moment(val).format('LLL');
  };
  const renderTimeFormat = (val) => {
    if (!val) return '';
    return moment(val, 'HH:mm:ss').format('hh:mm A');
  };
  const renderDaysInterval = (val) => {
    if (!val) return '';

    const today = moment().startOf('day');
    const target = moment(val).startOf('day');

    const diffDays = target.diff(today, 'days');

    if (diffDays < 0) return 'Expired';
    if (diffDays === 0) return 'Today';

    return `${diffDays} day${diffDays > 1 ? 's' : ''} left`;
  };
  const renderMonthDateFormat = (val) => {
    if (!val) return '';
    return moment(val).format('MMMM D');
  };
  const renderDayFormat = (val) => {
    if (!val) return '';
    return moment(val).format('D');
  };
  const renderMonthFormat = (val) => {
    if (!val) return '';
    return moment(val).format('MMM');
  };

  const renderFullMonthFormat = (val) => {
    if (!val) return '';
    return moment(val).format('MMMM');
  };
  const renderYearsInService = (years) => `${years} ${years === 1 ? 'year' : 'years'} in service`;
  const currentDateLabel = computed(() => {
    return `${moment().tz('Asia/Manila').format('MMMM D, YYYY | dddd')} (PHT)`;
  });
  return {
    renderDateFormat,
    currentDateLabel,
    renderMonthDateFormat,
    renderYearsInService,
    renderDayFormat,
    renderMonthFormat,
    renderTimeFormat,
    renderDaysInterval,
    renderFullMonthFormat,
    renderDateTimeFormat
  };
}
